import React from "react";

const Payroll = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          fillRule="evenodd"
          clipRule="evenodd"
          className="u_fill"
          d="M30.93 2H16.575 30.93zm-1.674 26.392l.002-24.72-16.655.073v2.228h14.353v22.42h2.3zm-5.481-9.245a7.297 7.297 0 10-14.594 0 7.297 7.297 0 0014.594 0zM30.929 2v28.137h-3.973v1.106L24.2 34l-1.94-1.94-1.966 1.935-1.918-1.918-1.95 1.918-1.918-1.918-1.951 1.918-1.93-1.93L8.692 34 6 31.308V5.973h4.858V2H30.929zM18.974 19.613c.546 1.06.322 2.637-.68 3.391a2.66 2.66 0 01-1.084.463l.131 1.015h-1.774l.135-1.046a2.595 2.595 0 01-1.022-.496c-.563-.46-.855-1.146-.988-1.845l1.35-.305c.117.724.655 1.297 1.453 1.297.45 0 .788-.115 1.016-.343.292-.292.444-.734.287-1.12-.206-.508-.836-.655-1.326-.8-.553-.164-1.128-.31-1.603-.638-1.417-.977-1.317-3.341.323-4.057.168-.073.345-.122.525-.16l-.15-1.158h1.774l-.152 1.178c.295.068.58.173.832.332.533.337.822.876.95 1.453l-1.417.28a1.116 1.116 0 00-.345-.523 1.209 1.209 0 00-.716-.238c-.461-.015-1.063.104-1.24.569a.719.719 0 00.166.753c.176.178.604.363 1.283.556.68.192 1.182.392 1.508.598.325.206.58.487.764.844z"
          fill={fill}
      />
    </svg>
);

export default Payroll;
